const EXPECTED_OWNER_LOGIN_AS_CREATE_CODES = new Set([
  "missingParameters",
  "advertiserNotFound",
  "forbidden",
  "unauthorized",
]);

export const isExpectedOwnerLoginAsCreateCode = (code) =>
  EXPECTED_OWNER_LOGIN_AS_CREATE_CODES.has(code);
